import { Box, CircularProgress, Typography } from "@mui/material";
import { useNextMatch } from "../../hooks/useNextMatch";
import * as styles from "./matchDayStyles";
import { useCookieConsent } from "../../contexts/CookieConsentContext";
import { MatchDaySettings } from "../../types/Settings";

interface MatchDayProps {
    settings: MatchDaySettings;
}

const MatchDay: React.FC<MatchDayProps> = ({ settings }) => {
    const { data: nextMatch, isLoading, error } = useNextMatch(settings);
    const { hasConsented } = useCookieConsent();

    if (!hasConsented || !settings.show) {
        return null;
    }

    return (
        <Box sx={styles.matchDayStyles}>
            <Box sx={styles.matchDayBackgroundStyles(settings.colorScheme)}>
                <Box sx={styles.matchDayContentStyles}>
                    <Typography variant="h4" sx={styles.welcomeTextStyles}>
                        Nächste Begegnung
                    </Typography>

                    {isLoading && (
                        <Box sx={styles.loadingStyles}>
                            <CircularProgress
                                color="inherit"
                                size={24}
                                sx={{ mr: 2 }}
                            />
                            Lade Spieldaten...
                        </Box>
                    )}

                    {error && (
                        <Typography variant="body1" sx={styles.errorStyles}>
                            Spieldaten konnten nicht geladen werden
                        </Typography>
                    )}

                    {nextMatch && (
                        <>
                            <Box sx={styles.teamsContainerStyles}>
                                <Box
                                    component="img"
                                    sx={styles.teamLogoStyles}
                                    alt="HSV Logo"
                                    src="/images/illustrations/hsv-icon.svg"
                                />

                                <Typography
                                    variant="h4"
                                    sx={styles.vsTextStyles}
                                >
                                    vs.
                                </Typography>

                                <Box
                                    component="img"
                                    sx={styles.teamLogoStyles}
                                    alt={`${nextMatch.opponent.teamName} Logo`}
                                    src={nextMatch.opponent.teamIconUrl}
                                />
                            </Box>

                            <Typography
                                variant="h6"
                                sx={styles.matchSubtitleStyles}
                            >
                                {nextMatch.formattedDate}
                                {!nextMatch.isRunning && " Uhr"}
                            </Typography>

                            <Typography
                                variant="h6"
                                sx={styles.matchSubtitleStyles}
                            >
                                {nextMatch.isHome
                                    ? "Heimspiel"
                                    : "Auswärtsspiel"}{" "}
                                vs. {nextMatch.opponent.teamName}
                            </Typography>
                        </>
                    )}

                    {!nextMatch && !isLoading && !error && (
                        <Typography variant="body1" sx={styles.errorStyles}>
                            Keine anstehenden Spiele gefunden
                        </Typography>
                    )}
                </Box>
            </Box>
        </Box>
    );
};

export default MatchDay;
